import { render, staticRenderFns } from "./ptp-modify.vue?vue&type=template&id=84d6ba24"
import script from "./ptp-modify.vue?vue&type=script&lang=ts"
export * from "./ptp-modify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports